import { createContext } from "react";
/**
 * Show inactive attributes
 *
 * - used to control the the default selectors for the configurations
 * - must be set to `true` in layout editor, so all attributes can be included in the layout
 *
 * Example for inactive attributes
 * - CFG_NOTEBOOK A_HARD_DISK
 *
 * @category Settings
 */
export const ShowInactiveAttributesContext = createContext(false);
ShowInactiveAttributesContext.displayName = "ShowInactiveAttributes";
//# sourceMappingURL=ShowInactiveAttributesContext.js.map